module.exports = __webpack_public_path__ + "img/1.d1bea310.png";